export default __webpack_public_path__ + "static/media/health-challenges.76e6245b.svg";